export enum InterestChoices {
  LOWEST_PAYMENT = 'LOWEST_PAYMENT',
  LOWEST_INTEREST_RATE = 'LOWEST_INTEREST_RATE',
  CHECKING_OPTIONS = 'CHECKING_OPTIONS',
}
